<template>
    <div>
        <h1>Credentialer Assignment</h1>
        <div class="card">
            <div class="card-body">
                <b-row>
                    <b-col>
                        <h2 class="green-header">Unassigned Applications: </h2>
                        <UnassignedTableList slug="pendingApplications" :items="pendingApplications" :isLoading ="isAppLoading"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h2 class="green-header">Unassigned Change Requests: </h2>
                        <UnassignedChangeTableList slug="pendingChanges" :items="pendingChanges" :isLoading ="isChangeLoading"/>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import {toastService} from "@/mixins/toastService";
    import moment from 'moment';
    import UnassignedTableList from "@/components/templates/UnassignedTableList.vue"
    import UnassignedChangeTableList from "@/components/templates/UnassignedChangeTableList.vue"

    axiosRetry(axios, {
        retries: 3,
        retryDelay: axiosRetry.exponentialDelay
    })

    export default {
        data() {
            return {
                pendingApplications: [],
                pendingChanges: [],
                isAppLoading: false,
                isChangeLoading: false,
            }
        },
        mixins: [
            toastService,
        ],
        components: {
            UnassignedTableList,
            UnassignedChangeTableList
        },
        methods: {
            loadPending() {
                this.isAppLoading = true
                this.isChangeLoading = true
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/app/pending-assign`)
                    .then(response => {
                        this.pendingApplications = response.data
                        this.isAppLoading = false
                    })
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/change/pending-assign`)
                    .then(response => {
                        this.pendingChanges = response.data
                        this.isChangeLoading = false
                    })
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
        },
        created() {
            document.title = "Credentialer Management - NAR"
            this.loadPending();
        },
    }
</script>
